module.exports = __webpack_public_path__ + "static/media/user.7ced2474.svg";